import { createFileRoute } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export const Route = createFileRoute('/')({
  component: Home,
});

function Home() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-6">
      <img src="/logo-mark.svg" alt="" className="h-16 w-16" />
      <h1 className="font-display text-display font-black tracking-tight text-ink">
        Arti Pilotage
      </h1>
      <p className="text-body text-muted-foreground">
        Le pilotage d&apos;entreprise, brique par brique.
      </p>
      <Button size="lg">Commencer</Button>
    </main>
  );
}
